import { Component, inject, model, OnInit } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { Segment, SegmentOption } from "@malirang/front-share";
import { injectNavigationEnd } from "ngxtension/navigation-end";

/**
 * 서비스 관리
 */
@Component({
    selector: "app-center-template-layout",
    templateUrl: "./center-template.layout.html",
    imports: [Segment, RouterOutlet],
})
export class CenterTemplateLayout implements OnInit {
    readonly router = inject(Router);

    navigationEnd$ = injectNavigationEnd();

    segment = model<string>("ticket");
    segmentOptions: SegmentOption[] = [
        { label: "서비스 유형 관리", value: "ticket" },
        { label: "바우처 유형 관리", value: "voucher" },
        { label: "치료유형 관리", value: "ticket-type" },
        { label: "태그 관리", value: "tag" },
    ];

    ngOnInit(): void {
        this.setSegment();

        this.navigationEnd$.subscribe(() => {
            this.setSegment();
        });
    }

    setSegment() {
        this.segment.set(this.router.url.split("/").pop()!);
    }

    handleSegmentChange() {
        this.router.navigate(["/center/template", this.segment()]);
    }
}
